import { createSlice } from '@reduxjs/toolkit'

const videoSlice = createSlice({
  name: 'video',
  initialState: {
    open: false,
    videoUrl: '',
  },
  reducers: {
    showVideo: (_, { payload }) => ({ open: true, videoUrl: payload }),
    hideVideo: (_) => ({ open: false, videoUrl: '' }),
  }
})

export const { showVideo, hideVideo } = videoSlice.actions

export default videoSlice.reducer